export default __webpack_public_path__ + "navigation-overview-setup-ib-960-85e22cd594abd405d1b38ed20c0dd669.webp";